"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var constants_1 = require("../constants");
var propTypes = {
    code: prop_types_1.default.string.isRequired,
    className: prop_types_1.default.string,
    TextComponent: prop_types_1.default.any
};
var Flag = /** @class */ (function (_super) {
    __extends(Flag, _super);
    function Flag() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Flag.prototype.render = function () {
        var _a = this.props, code = _a.code, _b = _a.TextComponent, TextComponent = _b === void 0 ? 'div' : _b, props = __rest(_a, ["code", "TextComponent"]);
        var flagImageUrl = '';
        if (constants_1.COUNTRY_CODES.includes(code.toLowerCase())) {
            flagImageUrl = constants_1.S3_FLAG_BUCKET_URL + "/" + code.toLowerCase() + ".svg";
        }
        else {
            flagImageUrl = constants_1.S3_FLAG_BUCKET_URL + "/null.svg";
        }
        return (react_1.default.createElement(TextComponent, __assign({ "data-key": code }, props),
            react_1.default.createElement("img", { src: flagImageUrl, alt: code + " flag" })));
    };
    return Flag;
}(react_1.Component));
// @ts-ignore
Flag.propTypes = propTypes;
exports.default = Flag;
//# sourceMappingURL=flag.js.map